import { getMetaFromJcamp, getTargetProperty, referenceFind, } from "../common.js";
const cyclicVoltammetry = {
    jpath: ['spectra', 'cyclicVoltammetry'],
    find: referenceFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default cyclicVoltammetry;
//# sourceMappingURL=cyclicVoltammetry.js.map